import { ECreationStatus } from "./creation";
import type { TContentItem } from "./content";
import { TUserProfile } from "./user";

/** File media categories returned by the resource API. */
export enum EFileType {
  OTHER = 0,
  IMAGE = 1,
  AUDIO = 2,
  VIDEO = 3,
  JSON = 4,
  ZIP = 5,
  TXT = 6,
}
/** Stored file metadata attached to a resource. */
export type TFile = {
  id: string;
  url: string;
  title?: string;
  type: EFileType; // 资源类型
  size?: number; // 文件大小
  ext?: string;
  data?: {
    duration?: number; // 视频时长
    width?: number; // 图片宽度
    height?: number; // 图片高度
    cover_id?: string;
  };
  transcodes?: {
    resolution: string; // 分辨率
    url: string;
    status: number;
  }[];
};

/** Resource business categories used by creation and Actor entities. */
export enum ENodeResourceType {
  // 基础类型

  UNKNOWN = 0,
  // 基础类型
  BACKGROUND_IMAGE = 10001,
  FOREGROUND_IMAGE = 10002,
  CHARACTER_IMAGE = 10102,
  CHARACTER_VIDEO = 10304,
  STORY_ACTION_IMAGE = 10105,
  STORY_ACTION_VIDEO = 10305,
  ACTION_IMAGE = 10103,
  ACTION_VIDEO = 10301,
  STORY_SCENE_IMAGE = 10104,
  STORY_SCENE_VIDEO = 10302,
  SCENE_IMAGE = 10101,
  SCENE_VIDEO = 10303,
  ITEM_AUDIO = 10201,

  // 复合类型
  NOVEL_THEME = 30001,
  NOVEL_RESOURCE = 30002,
  NOVEL_CHAPTER_RESOURCE = 30003,
  NOVEL_AUDIO = 30004,

  // 演员头像
  ACTOR_THEME = 60101,
  // 演员资料资源
  ACTOR_RESOURCE = 60102,
  ACTOR_IMAGE = 60201, // 一般ACTOR的参考图，或通用图片。
  ACTOR_THREE_VIEWS = 60202, // 三视图。

  SHORTS_EPISODE_RESOURCE = 50003,
  EPISODE_VIDEO = 50001,
}

export type TThemeData = {
  mode?: "dark" | "light";
  image_mode?: "standard" | "advanced";
  bg_color?: string;
  text_color?: string;
  bg_color_dark?: string;
  bg_color_light?: string;
  text_color_dark?: string;
  text_color_light?: string;
  bg_image_id?: string;
  fg_image_id?: string;
  fg_video_id?: string;
  [key: string]: unknown;
};

export type TResourceData = TThemeData & {
  content?: TContentItem[];
  introduction?: TContentItem[];
  subtitles?: Record<string, string>;
  original?: string;
};

export type TUpsertCreationResourceReq = {
  id?: string;
  title?: string;
  type?: ENodeResourceType;
  node_id: string;
  file_id?: string;
  file_ids?: string[];
  data?: TResourceData;
};

/** Resource metadata returned by entity resource APIs. */
export type TResource = {
  id: string;
  node_id: string;
  root_id: string;
  title: string;
  type: ENodeResourceType;
  file_id?: string; // 关联的文件ID
  file_ids?: string[]; // 关联的文件ID列表
  file?: TFile;
  files?: TFile[]; // 多文件资源
  data?: TResourceData; // 额外数据
  user?: TUserProfile;
  user_id?: string;

  status?: ECreationStatus;
};

/** Theme resource returned by entity APIs. */
export type TTheme = Omit<TResource, "data"> & {
  data?: TThemeData;
};
